module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-center_po"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "Backed/img/portalistlogo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "end-title_po"
  }, [_vm._v("The Galaxy’s Greatest Newsletter"), _c('br'), _vm._v("Delivered to Your Inbox")]), _vm._v(" "), _c('p', {
    staticClass: "end-title_po1"
  }, [_vm._v("Get awesome tales of fantasy and science fiction once a week.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center_po1"
  }, [_c('a', {
    attrs: {
      "href": "http://theportalist.com/newsletters",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "Backed/img/pro-signup.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "end-title_po2"
  }, [_vm._v("Visit us at "), _c('a', {
    attrs: {
      "href": "http://theportalist.com/newsletters",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink"
  }, [_vm._v("www.theportalist.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27850521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Backed/portalistad_1.vue
// module id = 60
// module chunks = 0